import * as React from 'react';
import { Image, UIHeading5, UIText2 } from '@cian/ui-kit';
import * as styles from './MortgagePromoCard.css';

interface IMortgagePromoCardProps {
  activeToDate: string;
  logoUrl: string;
  name: string;
  onClick?(): void;
}

export const MortgagePromoCard = React.forwardRef<HTMLDivElement, IMortgagePromoCardProps>(
  ({ activeToDate, logoUrl, name, onClick }, ref) => {
    return (
      <div ref={ref} className={styles['card']} onClick={onClick} role="button" tabIndex={0}>
        <div className={styles['logo']}>
          <Image src={logoUrl} height="100%" width="100%" />
        </div>
        <UIHeading5 as="h3">
          <span className={styles['name']}>{name}</span>
        </UIHeading5>
        <div className={styles['active-date']}>
          <UIText2 color="gray60_100">{activeToDate}</UIText2>
        </div>
      </div>
    );
  },
);

MortgagePromoCard.displayName = 'MortgagePromoCard';
